import { render, staticRenderFns } from "./ProjectT.vue?vue&type=template&id=0a2c7ed8&scoped=true&"
import script from "./ProjectT.vue?vue&type=script&lang=ts&"
export * from "./ProjectT.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectT.vue?vue&type=style&index=0&id=0a2c7ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c7ed8",
  null
  
)

export default component.exports